export let infoMsg = {
  log: "",
  pw0: "",
  pw1: "",
};

export let infoAuthMsg = {
  log: "",
  pw0: "",
};
